module.exports = __webpack_public_path__ + "img/img2.65c7f509.png";